export function shouldUpdateScroll(prevRouterProps, nextRouterProps) {
  if (!prevRouterProps) {
    return false;
  }
  return true;
}



// WEBPACK FOOTER //
// ../gatsby-browser.js